module.exports = "//cdn.mxpnl.com/static/asset-cache/7be137c1598b953ec0d50e7014e53395/iron/common/widgets/intro/event-carousel/images/croissant-event.png";